import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../theme/colors';

export const useTimelineCardStyles = makeStyles((theme) => ({
  card: {
    marginTop: '2rem',
    padding: '2rem',
    minHeight: '350px',
    background: `linear-gradient(to bottom, #fff, #EDF0F7 350px)`,
    [theme.breakpoints.down('md')]: {
      marginTop: '16px',
      padding: '16px'
    }
  },
  title: {
    fontSize: '12px',
    color: Colors.timelineGray,
    textTransform: 'uppercase'
  }
}));
